import React from "react";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { BuyerListingOptionProps } from "../buyerListingTypes";
import { useGridApiContext } from "@mui/x-data-grid";
import { BuyerListingOptionsProvider } from "./buyerListingOptionsProvider";

// Custom styles for the dropdown menu
const menuProps = {
  PaperProps: {
    sx: {
      maxHeight: 300,
      "& .MuiMenuItem-root": {
        height: 30,
      },
    },
  },
};
interface BuyerListingOptionPropsExtended extends BuyerListingOptionProps {
  field: string;
}

const BuyerListingOption: React.FC<BuyerListingOptionPropsExtended> = (
  props
) => {
  const { id, field, value, handleChangeText, params } = props;
  const apiRef = useGridApiContext();
  const removeMethodOfContactOption = "Remove Method of Contact";
  const noneOption = "None";
  const handleChange = (event: SelectChangeEvent<string>) => {
    if (!id || !field) return;
    const newValue = event.target.value;
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue,
    });

    handleChangeText(id.toString(), field, newValue, params);
  };

  const options =
    BuyerListingOptionsProvider.getOptionsByField(params.field) || [];

  return (
    <Select
      value={value}
      onChange={handleChange}
      fullWidth
      MenuProps={menuProps}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          disabled={
            option.label === removeMethodOfContactOption
              ? value === ""
              : option.label === noneOption
              ? value === ""
              : false
          }
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default BuyerListingOption;
